import { Outlet, Route, Routes } from 'react-router-dom'
import { PageTitle } from '../../../../_metronic/layout/core'
import { UnidadesListWrapper } from './unidades-list/UnidadesList'
import { useT } from '_metronic/i18n/Metronici18n'

export const UnidadesPage = () => {
  const { t } = useT()
  return (
    <Routes>
      <Route element={<Outlet />}>
        <Route
          path=''
          element={
            <>
              <PageTitle description={t('pagina.unidade.descricao')}>Unidades/Setores</PageTitle>
              <UnidadesListWrapper />
            </>
          }
        />
      </Route>
    </Routes>
  )
}
